import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/dream-energy/introduction_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1317}
              height={1058}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#75CB4C" }}>Introduction</span>
            </h2>
            <p>
              Certified Business Energy Professionals and experienced industry
              experts offer unbiased advice, before and after sale consultation,
              and procure the lowest electricity rate based on your businesses'
              unique usage trend.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
